import CryptoJS from "crypto-js";
import axios from "axios";
import { baseUrl, encryptionKey as encryptionKeyUrl } from "./urls";

let cachedKey = null;
let fetchKeyPromise = null;

const getAuthHeaders = () => {
  try {
    const tokensJson = localStorage.getItem("authTokens");
    const tokens = JSON.parse(tokensJson);
    const access = tokens?.access;
    return access ? { Authorization: `Bearer ${access}` } : {};
  } catch {
    return {};
  }
};

export const fetchEncryptionKey = async () => {
  if (cachedKey) return cachedKey;
  if (fetchKeyPromise) return fetchKeyPromise;

  fetchKeyPromise = (async () => {
    try {
      const response = await axios.get(`${baseUrl}${encryptionKeyUrl}`, {
        headers: getAuthHeaders(),
      });

      const keyHex = response.data?.key;
      if (!keyHex) throw new Error("Encryption key not found in response");

      cachedKey = keyHex;
      return cachedKey;
    } finally {
      fetchKeyPromise = null;
    }
  })();

  return fetchKeyPromise;
};

export const clearEncryptionKey = () => {
  cachedKey = null;
  fetchKeyPromise = null;
};

export const encrypt = (plaintext, keyHex) => {
  const key = CryptoJS.enc.Hex.parse(keyHex);
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(plaintext, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return {
    iv: iv.toString(CryptoJS.enc.Hex),
    ciphertext: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
  };
};

export const decrypt = (ivHex, ciphertextHex, keyHex) => {
  const key = CryptoJS.enc.Hex.parse(keyHex);
  const iv = CryptoJS.enc.Hex.parse(ivHex);
  const ciphertext = CryptoJS.enc.Hex.parse(ciphertextHex);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: ciphertext },
    key,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const encryptRequestData = (data, keyHex) => {
  const payload = typeof data === "string" ? data : JSON.stringify(data);
  return encrypt(payload, keyHex);
};

export const decryptResponseData = (ivHex, ciphertextHex, keyHex) => {
  const decrypted = decrypt(ivHex, ciphertextHex, keyHex);
  try {
    return JSON.parse(decrypted);
  } catch {
    return decrypted;
  }
};
